import { Link } from "react-router-dom";
import { Instagram, Youtube, Linkedin, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[hsl(var(--line))] bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-6">
            <p className="overline mb-6"><span className="section-mark">Let's build together</span></p>
            <h3 className="font-display text-4xl sm:text-5xl md:text-6xl font-light leading-[1.02] tracking-[-0.03em] text-ink">
              Numbers people <span className="font-display-italic">trust</span>.<br />
              Stories people <span className="font-display-italic text-terracotta">share</span>.
            </h3>
            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <Link
                to="/contact"
                data-testid="footer-cta-discovery"
                className="inline-flex items-center justify-center rounded-full bg-ink text-white px-7 py-4 text-[13px] font-medium tracking-wide hover:bg-terracotta transition-colors"
              >
                Book a Discovery Call
              </Link>
              <Link
                to="/contact"
                data-testid="footer-cta-collab"
                className="inline-flex items-center justify-center rounded-full border border-stone-300 px-7 py-4 text-[13px] font-medium tracking-wide text-ink hover:border-ink transition-colors"
              >
                Start a Collaboration
              </Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Pages</p>
            <ul className="space-y-3 text-ink-soft">
              <li><Link to="/" className="hover:text-ink">Home</Link></li>
              <li><Link to="/about" className="hover:text-ink">About</Link></li>
              <li><Link to="/services" className="hover:text-ink">Services</Link></li>
              <li><Link to="/collaborations" className="hover:text-ink">Collaborations</Link></li>
              <li><Link to="/contact" className="hover:text-ink">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Reach out</p>
            <ul className="space-y-3 text-ink-soft text-sm">
              <li className="flex items-center gap-2"><Mail size={14} /> teamcanitin@gmail.com</li>
              <li className="flex items-center gap-2"><Phone size={14} /> +91 98711 43039</li>
              <li>Delhi, India</li>
            </ul>
            <div className="mt-6 flex items-center gap-4 text-ink">
              <a href="https://www.instagram.com/canitinsharmaa/" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-ig" className="hover:text-terracotta"><Instagram size={18} /></a>
              <a href="https://www.youtube.com/@ca_nitinsharma" target="_blank" rel="noreferrer" aria-label="YouTube" data-testid="footer-yt" className="hover:text-terracotta"><Youtube size={18} /></a>
              <a href="https://www.linkedin.com/in/canitin-sharma/" target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="footer-li" className="hover:text-terracotta"><Linkedin size={18} /></a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[hsl(var(--line))] flex flex-col sm:flex-row justify-between gap-3 text-xs text-ink-soft">
          <p>© {new Date().getFullYear()} CA Nitin Sharma. All rights reserved.</p>
          <p>
            Crafted by{" "}
            <a
              href="https://brandchilly.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-brandchilly"
              className="text-ink hover:text-terracotta underline-offset-4 hover:underline transition-colors"
            >
              Brandchilly
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
}
